import React from "react";
import "./Sponsors.css";

const Sponsors = () => {
  const sponsors = [
    {
      name: "Mr. AN Annamalai",
      location: "Chennai",
      amount: "₹ 5,250",
      cause: "Towards providing educational kits to government primary school children in Bangalore.",
      date: "28.10.2024"
    },
    {
      name: "Mr. Lakshmanan",
      location: "Hosur",
      amount: "₹ 1,500",
      cause: "Towards providing educational kits to students at evening study centers in remote villages around Hosur.",
      date: "22.11.2024"
    }
  ];
  const supportMatters = [    {
      icon: "🎓",
      text: "Empowers children with joyful, curriculum-aligned learning"
    },
    {
      icon: "🧩",
      text: "Provides access to interactive educational tools"
    },
    {
      icon: "👨‍🏫",
      text: "Helps train educators and volunteers"
    },
    {
      icon: "🌍",
      text: "Builds a more equitable learning ecosystem"
    }
  ];
  return (
    <div className="sponsors-page">      <div className="sponsors-hero">
        <div className="sponsors-hero-content">
          <div className="banner-text">
            <h1>❤️ OUR VALUABLE SPONSORS</h1>
            <p className="banner-subtitle">
              We gratefully acknowledge the generous support of our sponsors who have contributed
              towards providing game-based education and skill training to underprivileged children.
              Your contribution enables us to make education more engaging, accessible, and
              inclusive for all children.
            </p>
          </div>
        </div>
      </div>

      <section className="sponsors-showcase">
        <h2>Our Generous Contributors</h2>
        <div className="sponsors-grid">
          {sponsors.map((sponsor, index) => (
            <div className="sponsor-card" key={index}>
              <div className="sponsor-header">
                <h3>{sponsor.name}</h3>
                <div className="sponsor-location">{sponsor.location}</div>
                <div className="sponsor-amount">{sponsor.amount}</div>
              </div>
              <div className="sponsor-details">
                <div className="sponsor-cause">
                  <strong>Contribution:</strong>
                  <p>{sponsor.cause}</p>
                </div>
                <div className="sponsor-date">
                  <strong>Date:</strong> {sponsor.date}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="why-support-section">
        <h2>Why Your Support Matters</h2>
        <div className="support-grid">
          {supportMatters.map((matter, index) => (
            <div className="support-item" key={index}>
              <div className="support-icon">{matter.icon}</div>
              <p>{matter.text}</p>
            </div>
          ))}
        </div>
      </section>      <section id="support-us-section" className="support-us-section">
        <div className="support-us-container">
          <h2>Want to Support Us?</h2>
          <div className="support-content">
            <p>
              If you or your organization would like to join us in making learning joyful and impactful for
              every child, please get in touch:
            </p>
            <p className="minimum-support">
              *Sponsorships of ₹1,000 or more are gratefully accepted.
            </p>
          </div>
          <div className="contact-cards">
            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <div className="contact-label">Email</div>
              <a href="mailto:contact@curiosense.co.in">contact@curiosense.co.in</a>
            </div>
            <div className="contact-card">
              <div className="contact-icon">📞</div>
              <div className="contact-label">Phone</div>
              <a href="tel:+919901940345">+91-9901940345</a>
            </div>
            <div className="contact-card">
              <div className="contact-icon">🌐</div>
              <div className="contact-label">Website</div>
              <a href="https://www.curiosense.co.in" target="_blank" rel="noopener noreferrer">www.curiosense.co.in</a>
            </div>
          </div>
        </div>
      </section>

      <section className="collaboration-section">
        <div className="collaboration-container">
          <h2>Interested in Collaborating?</h2>
          <p>
            If you're passionate about transforming education and would like to learn more about collaboration opportunities with Curiosense Innovations, 
            please reach out to us at <a href="mailto:contact@curiosense.co.in">contact@curiosense.co.in</a>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Sponsors;